import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useMemo } from "react";

import type { Frame } from "@/types/dragon-tiles";

import { bulkFrameVariantPreviewsQueryOptions } from "@/api/dragon-tiles";
import {
  collectFrameVariantIds,
  seedFrameVariantPreviewCache,
} from "@/utils/frameVariantPreviews";

export function useBulkFrameVariantPreviews(siteId: string, frames: Frame[]) {
  const queryClient = useQueryClient();

  const frameVariantIds = useMemo(
    () => collectFrameVariantIds(frames),
    [frames],
  );

  const {
    data: bulkPreviews = {},
    isPending: isVariantPreviewsPending,
    isFetching: isVariantPreviewsFetching,
  } = useQuery(bulkFrameVariantPreviewsQueryOptions(siteId, frameVariantIds));

  useEffect(() => {
    if (Object.keys(bulkPreviews).length > 0) {
      seedFrameVariantPreviewCache(queryClient, siteId, bulkPreviews);
    }
  }, [bulkPreviews, siteId, queryClient]);

  return {
    bulkPreviews,
    isVariantPreviewsPending,
    isVariantPreviewsFetching,
  };
}
